// extracted by mini-css-extract-plugin
export var heroNamecheck = "HeroNamecheck--heroNamecheck--IxAJS";
export var heroNamecheck__heading = "HeroNamecheck--heroNamecheck__heading--+j1MD";
export var heroNamecheck__hero = "HeroNamecheck--heroNamecheck__hero--Jl9w-";
export var heroNamecheck__hero___hidden = "HeroNamecheck--heroNamecheck__hero___hidden--b+llA";
export var heroNamecheck__subheading = "HeroNamecheck--heroNamecheck__subheading--2Q7l7";
export var illustration = "HeroNamecheck--illustration--M9m6A";
export var tkMyriadProSemiCondensed = "HeroNamecheck--tk-myriad-pro-semi-condensed--y9Vr+";